<template>
  <swiper-base
    ref="swiper"
    class="swiper-type-one"
    :items="items"
    :last-item-offset="lastItemOffset"
    @change="onChange"
  >
    <template v-slot:item="{ item }">
      <slot name="item" :item="item"></slot>
    </template>

    <template v-slot:buttons>
      <u-icon-button
        v-if="hasPrevButton"
        class="swiper-type-one__button swiper-type-one__button--prev"
        icon-name="left"
        size="m"
        dark
        @click="onSwipe('end')"
      >
        prev
      </u-icon-button>
      <u-icon-button
        v-if="hasNextButton"
        class="swiper-type-one__button swiper-type-one__button--next"
        icon-name="right"
        size="m"
        dark
        @click="onSwipe('start')"
      >
        next
      </u-icon-button>
    </template>
  </swiper-base>
</template>

<script>
import { UIconButton } from 'universkin-shared';

import SwiperBase from '@/components/common/app-swiper/SwiperBase.vue';

export default {
  name: 'SwiperTypeOne',
  components: { SwiperBase, UIconButton },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return { currentItemIndex: 0 };
  },
  computed: {
    hasPrevButton() {
      return this.currentItemIndex > 0;
    },
    hasNextButton() {
      return this.currentItemIndex < this.items.length - 1 - this.lastItemOffset;
    },
    lastItemOffset() {
      return this.$windowWidth.value >= 1440 ? 1 : 0;
    }
  },
  methods: {
    onSwipe(direction) {
      this.$refs.swiper.swipeInDirection(direction);
    },
    onChange(index) {
      this.currentItemIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-type-one {
  position: relative;
  --item-width: 75vw;
  --item-gap: 16px;

  &__button {
    display: none;
  }
}

@media (min-width: 480px) {
  .swiper-type-one {
    --item-width: 60vw;
  }
}

@media (min-width: 600px) {
  .swiper-type-one {
    --item-width: 42vw;
  }
}

@media (min-width: 960px) {
  .swiper-type-one {
    --item-width: 30vw;
    --item-gap: 24px;

    &__button {
      display: block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      &:lang(ar) {
        transform: translateY(-50%) scale(-1); // swap arrow direction on button
      }
    }

    &__button--prev:not(:lang(ar)),
    &__button--next:lang(ar) {
      left: 40px;
    }

    &__button--next:not(:lang(ar)),
    &__button--prev:lang(ar) {
      right: 40px;
    }
  }
}

@media (min-width: 1440px) {
  .swiper-type-one {
    --item-width: 24vw;

    &__button--prev:not(:lang(ar)),
    &__button--next:lang(ar) {
      left: 60px;
    }

    &__button--next:not(:lang(ar)),
    &__button--prev:lang(ar) {
      right: 60px;
    }
  }
}
</style>
